export default __webpack_public_path__ + "static/media/Klippehelligdommen.4cda96a2.svg";